import { Icon } from '../ui/Icon'
import { Sheet } from '../ui/Sheet'
import { type Row } from './status'

/**
 * The discard confirmation — the panel's ONE irreversible action, so the sheet names
 * every file and which of the two deaths it will die (restore a tracked file, DELETE
 * an untracked one). Split out of GitPanel.tsx in M6 (拆面板, 2026-09-03), verbatim.
 */
export function DiscardConfirm({
  rows,
  host,
  repo,
  busy,
  onCancel,
  onConfirm,
}: {
  rows: Row[]
  /** Mounted remote this will run on; null = Origin. */
  host: string | null
  repo: string | null
  busy: boolean
  onCancel: () => void
  onConfirm: () => void
}) {
  const deleted = rows.filter((r) => r.kind === 'untracked')
  const restored = rows.filter((r) => r.kind !== 'untracked')

  return (
    <Sheet
      title={rows.length === 1 ? 'Discard changes' : `Discard changes in ${rows.length} files`}
      onClose={onCancel}
      actions={
        <>
          <button type="button" className="sheet-btn" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="sheet-btn danger" disabled={busy} onClick={onConfirm}>
            {busy ? 'Discarding…' : 'Discard'}
          </button>
        </>
      }
    >
      <p className="gitwarn">
        <Icon name="warning" size={15} />
        This cannot be undone.
      </p>
      {/*
        Name the machine and the repo, always.
        The proxy currently falls back to the LOCAL edge when a `?host=` mount is
        missing or has gone stale, and answers ok:true — so a discard aimed at a
        sleeping laptop can delete the edge's files instead. That is a backend bug
        (reported, and the fix is to fail rather than reroute), but a destructive
        prompt should state its target regardless: nobody should have to infer which
        machine they are about to delete files on.
      */}
      <div className="gittarget">
        <span>{host ? `on ${host}` : 'on Origin (this machine)'}</span>
        {repo && <code>{repo}</code>}
      </div>
      {restored.length > 0 && (
        <div className="gitconfirm-grp">
          <span>Restored from the last commit — your edits are lost</span>
          <ul>
            {restored.map((r) => (
              <li key={r.path}>{r.path}</li>
            ))}
          </ul>
        </div>
      )}
      {deleted.length > 0 && (
        <div className="gitconfirm-grp danger">
          <span>DELETED from disk — untracked, so there is no copy in git</span>
          <ul>
            {deleted.map((r) => (
              <li key={r.path}>{r.path}</li>
            ))}
          </ul>
        </div>
      )}
    </Sheet>
  )
}
